module.exports = __webpack_public_path__ + "static/media/组 4464@2x.87fc3302.png";